import { useEffect, useState } from "react";
import { UsuarioService } from "../../service/UsuarioService";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { TabPanel, TabView } from "primereact/tabview";
import { EmpresaUsuarioGrupo } from "./EmpresaUsuarioGrupo";
import { useLazyParams } from "../../hooks/useLazyParams";
import { TablaDinamica } from "../../components/TablaDinamica";
import { Generico } from "../../components/Generico";
import { EmpresaUsuario as EmpresaUsuarioModel } from "../../models/administracion/EmpresaUsuario";

export const EmpresaUsuario = ({ id, toast, generic, permss }) => {

    const tablaEstado = useLazyParams({ modelo: EmpresaUsuarioModel });
    const [sasignar, setSasignar] = useState([]);
    const usuarioService = new UsuarioService();
    const { funcSuccess, funcSistemaError } = Generico();

    useEffect(() => {
        loadLazyData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tablaEstado.lazyParams, id]);

    const loadLazyData = () => {
        const params = { ...tablaEstado.lazyParams, usuario: id, tipo: "empresa" };
        tablaEstado.setLoading(true);
        usuarioService.getUsuarioEmpresa({ lazyEvent: JSON.stringify(params) }).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);
            const inicial = [];
            res.data.registros.forEach(item => { if (item.fecha != null) { inicial.push(item.id); } });
            setSasignar(inicial);
        }).catch(error => {
            funcSistemaError(error, toast);
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    }

    const asignar = (e, rowData) => {
        const checked = e.checked;
        const idEmpresa = rowData.id;
        setFilaLoading(idEmpresa, true);
        tablaEstado.setLoading(true);
        usuarioService.putEmpresa({ id: idEmpresa, usu: id, agregar: checked, tipo: "empresa" }).then(res => {
            funcSuccess(res, toast);
            tablaEstado.refreshData();
        }).catch(error => {
            funcSistemaError(error, toast);
            setFilaLoading(idEmpresa, false);
            tablaEstado.setLoading(false);
        });
    }

    const setFilaLoading = (idEmpresa, isLoading) => {
        tablaEstado.setData(prevData => {
            return prevData.map(row => {
                if (row.id === idEmpresa) { return { ...row, loading: isLoading }; }
                return row;
            });
        });
    };

    const actionBodyTemplate = (rowData) => {
        if (!permss.crear && !permss.actualizar) return null;
        const isProcessing = rowData.loading === true;
        return (
            <div className="actions flex justify-content-center">
                {isProcessing ? (
                    <i className="pi pi-spin pi-spinner" style={{ fontSize: '1.5rem', color: 'var(--primary-color)' }}></i>
                ) : (
                    <Checkbox value={rowData.id} onChange={(e) => asignar(e, rowData)} checked={sasignar.includes(rowData.id)} />)}
            </div>
        );
    };

    const ColumnaAcciones = (
        <Column header='Asignar / Quitar' body={actionBodyTemplate} style={{ textAlign: 'center', width: '10rem' }} />
    );

    return (
        <TabView>
            <TabPanel header="Empresas" leftIcon="pi pi-building mr-2">
                <TablaDinamica modelo={EmpresaUsuarioModel} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" acciones={ColumnaAcciones} className="datatable-responsive" />
            </TabPanel>
            <TabPanel header="Grupos" leftIcon="pi pi-table mr-2">
                <EmpresaUsuarioGrupo id={id} toast={toast} generic={generic} permss={permss} />
            </TabPanel>
        </TabView>
    )
}